// extracted by mini-css-extract-plugin
export default {"TnCbgContainer":"TermsNConditions_TnCbgContainer__p3A8e","custom":"TermsNConditions_custom__v7qRa"};